
import { defineComponent, PropType } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useDriveStore } from '../store/driveStore';
import { useMainStore } from '@/store/mainStore';
import DriveAllPhotos from '../view-models/DriveAllPhotos.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import NotificationService from '@/services/NotificationService';
import { ICaseFilesManage, ITemporaryFile } from '@/types/interfaces';
import { PHOTO_VIEW_LAYOUT } from '@/types/enums';

export default defineComponent({
  props: {
    customControl: { type: Boolean, default: false },
    temporaryFiles: { type: Array as PropType<ITemporaryFile[]> },
  },
  emits: ['close', 'addSelectedPhotos'],
  components: {
    DriveAllPhotos,
    AppHeader,
    AppSearch,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    // fileUpdate(driveStore.photos, driveStore.currentCase.photos, MEDIA_TYPES.PHOTO);

    function fileUpdate() {
      if (props.customControl) {
        emit('addSelectedPhotos', { selected: driveStore.photos.data.filter((photo) => photo.selected), deselected: driveStore.photos.data.filter((photo) => !photo.selected) });
        return;
      }

      const promises: Promise<any>[] = [];
      const addFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;
      const removeFilePayload = {
        id: driveStore.currentCase.id!,
        fileIds: [],
      } as ICaseFilesManage;

      addFilePayload.fileIds = driveStore.photos.data
        .filter((photo) => photo.selected)
        .filter((photo) => !driveStore.currentCase.photos.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => photo.id);

      removeFilePayload.fileIds = driveStore.photos.data
        .filter((photo) => !photo.selected)
        .filter((photo) => driveStore.currentCase.photos.find((caseItem) => caseItem.contentId === photo.contentId))
        .map((photo) => driveStore.currentCase.photos.find((caseItem) => caseItem.contentId === photo.contentId)!.id);

      if (addFilePayload.fileIds.length) {
        promises.push(driveStore.addFilesToCase(addFilePayload));
      }
      if (removeFilePayload.fileIds.length) {
        promises.push(driveStore.removeFilesFromCase(removeFilePayload));
      }

      if (promises.length) {
        Promise.all(promises)
          .then((responses) => {
            if (responses.every((response) => response.success)) {
              driveStore.currentCase.updated = Date.now();
              // NotificationService.notifySuccess();
            }
          });
      }
      emit('close');
    }

    return {
      driveStore,
      fileUpdate,
      mainStore,
      PHOTO_VIEW_LAYOUT,
    };
  },
});
